import classNames from "classnames";

const ShippingOptionSkeleton = ({ className }) => (
  <div className={classNames("w-full animate-pulse", className)}>
    {/* Option button */}
    <div className="flex-1 border border-dark-gray rounded-lg px-3 pt-2 pb-6">
      <div className="flex justify-end">
        <div className="h-4 w-14 bg-light-purple/30 rounded-xl" />
      </div>

      <div className="mt-2 grid space-y-3 justify-items-center">
        <div className="w-36 h-[14px] bg-light-purple/30 rounded-lg" />
        <div className="w-52 h-3 bg-light-purple/30 rounded-lg" />
        <div className="w-52 h-3 bg-light-purple/30 rounded-lg" />
      </div>
    </div>

    {/* Duration */}
    <div className="mt-2 flex justify-center">
      <div className="w-20 h-2 bg-light-purple/20 rounded-lg" />
    </div>

    {/* Feature list */}
    <div className="mt-10">
      <div className="grid grid-cols-2 gap-4">
        {Array(8)
          .fill(0)
          .map((_, index) => (
            <div
              className="h-2 w-[96%] bg-light-purple/20 rounded-xl col-span-1"
              key={`skeleton-feature-list-item-${index}`}
            />
          ))}
      </div>
    </div>
  </div>
);

const LoadingSkeleton = () => {
  return (
    <div className="w-[86%] sm:w-5/6 pb-2 mx-auto flex flex-col md:flex-row gap-y-6 divide-y-2 md:divide-none md:space-x-6 lg:space-x-12 justify-between">
      <ShippingOptionSkeleton />
      <ShippingOptionSkeleton className="pt-8 md:pt-0" />
    </div>
  );
};

export default LoadingSkeleton;
